import Commons from '../../../Services/Common/Common';

/** 작업종료/작업후기 목록 조회 GetWoeBasicR2 (SP_WOE_BASIC_R2) */
export const WOE_BASIC_Schema = {
  mapper: {
    search1: {
      UserId: (context) => context.userInfo?.userid ?? '',
      AuthCd: (context) =>
        Commons.EncryptAES(context.userInfo?.authCd ?? '') || '',
       ApprovalYn: (context) =>
        Commons.EncryptAES(context.userInfo?.approvalYn ?? '') || '',
      SearchText: (context) =>
        Commons.EncryptAES(context.searchText ?? '') || '',
    },
  },
};
